import { render } from "./MainComponentV2.vue?vue&type=template&id=72538593&scoped=true"
import script from "./MainComponentV2.vue?vue&type=script&lang=js"
export * from "./MainComponentV2.vue?vue&type=script&lang=js"

import "./MainComponentV2.vue?vue&type=style&index=0&id=72538593&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72538593"]])

export default __exports__